import { css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../../common';

export const FiatWalletSkeleton = () => (
  <div
    data-testid="buy-source-fiat-wallet-skeleton"
    className={css({
      display: 'flex',
      pt: 'medium',
      pb: 'medium',
      justifyContent: 'space-between',
      gap: 'medium',
    })}
  >
    <div
      className={css({
        display: 'flex',
        gap: 'medium',
        alignItems: 'center',
        flex: 1,
      })}
    >
      <SkeletonElement width="40px" height="40px" borderRadius="50%" />

      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'extra_small_2',
          flex: 1,
        })}
      >
        <SkeletonElement width="56px" height="12px" borderRadius="4px" />
        <SkeletonElement width="40px" height="20px" borderRadius="4px" />
      </div>
    </div>

    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'extra_small_2',
        alignItems: 'flex-end',
        justifyContent: 'center',
      })}
    >
      <SkeletonElement width="52px" height="12px" borderRadius="4px" />
      <SkeletonElement width="64px" height="20px" borderRadius="4px" />
    </div>
  </div>
);
